import React from "react";
import { Link } from "react-router-dom";

// Image
import CVAnalyserImage from "../../assets/cv_analyser.png";

const CVTracker = () => {
    return (
        <section id="cv-analyser" className="w-full py-16 px-4 md:px-8 bg-white">
            <div className="max-w-7xl mx-auto rounded-lg overflow-hidden">
                <div className="flex flex-col md:flex-row items-stretch h-full">
                    {/* Mobile: Content first, Desktop: Content first */}
                    <div className="w-full md:w-1/2 pr-0 md:pr-12 mb-12 md:mb-0 order-1 md:order-1">
                        <p className="text-sm text-gray-600 mb-2 mt-4">AI-Powered CV Analyser</p>
                        <h2 className="text-[24px] md:text-4xl md:font-sans mb-4 md:mb-12">
                            Not Getting Interviews? Your CV Might Be Holding You Back.
                        </h2>
                        <p className="text-[16px] md:text-base mb-6 md:mb-12">
                            Upload your CV and receive instant, actionable feedback. Tailored for medical professionals, our analyser identifies weak points, gaps, and misalignments, then recommends improvements based on your specialty and goals.
                        </p>
                        <Link 
                            to="/signup"
                            className="inline-block bg-black text-white py-2 px-4 rounded-3xl hover:bg-gray-800 transition-colors"
                        >
                            Get Your Free CV Analysis
                        </Link>
                    </div>

                    {/* Mobile: Image second, Desktop: Image second */}
                    <div className="w-full md:w-1/2 rounded-3xl bg-[#E5F0F0] p-8 flex items-center justify-center order-2 md:order-2">
                        <div className="w-96 rounded-lg overflow-hidden">
                            <img
                                src={CVAnalyserImage}
                                alt="CV Analyser"
                                className="w-full h-full object-cover"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CVTracker;
